import React from "react";

interface LoadMoreButtonProps {
  isLoading: boolean;
  onClick: () => void;
}

export const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({
  isLoading,
  onClick,
}) => {
  return (
    <div
      className="mx-[16px] mt-[32px] flex cursor-pointer flex-row items-center gap-[12px] lg:mx-[75px] lg:mt-[80px]"
      onClick={onClick}
    >
      <p className="font-inter text-[18px] font-medium leading-[100%] tracking-[-0.01em] text-[#FFFEFD]">
        {isLoading ? "Loading..." : "Load More"}
      </p>
      {!isLoading && <img src="/assets/icons/Arrow.svg" alt="arrow" />}
    </div>
  );
};
